export const formId = 'received-invoice-notification-setting-form';
